import { Box, CircularProgress, Typography } from '@mui/material';
import { type FC } from 'react';

import { useActivityEventVideoUrl } from '../../api/activity.api.js';

interface Props {
  eventId: string;
  open: boolean;
}

const ActivityEventInlineClip: FC<Props> = ({ eventId, open }) => {
  const { data, isLoading, isError } = useActivityEventVideoUrl(eventId, { enabled: open });

  return (
    <Box
      sx={{
        mt: 1,
        borderRadius: 0.5,
        bgcolor: 'grey.900',
        overflow: 'hidden',
        // Fills whatever vertical space the parent (toast / drawer row)
        // hands it. `object-fit: contain` on the inner <video> letterboxes
        // any source resolution into that box.
        flex: 1,
        minHeight: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isLoading && <CircularProgress size={20} sx={{ color: 'grey.400' }} />}
      {isError && (
        <Typography variant="caption" sx={{ color: 'grey.400' }}>
          Clip unavailable
        </Typography>
      )}
      {data?.url && (
        <video
          src={data.url}
          controls
          autoPlay
          muted
          playsInline
          style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }}
        />
      )}
    </Box>
  );
};

export default ActivityEventInlineClip;
